"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookie = {
    get: function (cname, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        var context = document.cookie.split(';').find(function (c) { return c.trim().indexOf(cname) > -1; });
        if (context) {
            return context.split('=')[1] || null;
        }
        return defaultValue;
    },
    set: function (cookieName, cookieValue, cookieExpiryTime) {
        if (cookieExpiryTime === void 0) { cookieExpiryTime = 36500; }
        var date = new Date();
        date.setTime(date.getTime() + (cookieExpiryTime * 24 * 60 * 60 * 1000));
        document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toUTCString() + "; path=/";
        return cookieValue;
    },
    del: function (cname) {
        document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
        return true;
    },
};
/* tslint:disable */
function uuid() {
    var existingCookie = exports.cookie.get('_uca_uuid');
    if (existingCookie) {
        return existingCookie;
    }
    var r;
    var date = (new Date()).getTime();
    var randomNumber = Math.floor((Math.random() * 999999) + 9999).toString(16);
    return ("" + 'ucucucu'.substr(0, 8 - randomNumber.length) + randomNumber + "-" + 'yxxxxxxxxx-yxxx-yxxx-yxxx-xxxxxxxxxx'.replace(/[xy]/g, function (c) {
        r = ((date = Math.floor(date / 16)) + Math.random() * 16) % 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    }) + "-" + (new Date()).getTime());
}
exports.uuid = uuid;
function getQueryParam(name) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(window.location.href);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
exports.getQueryParam = getQueryParam;
exports.browserInfo = {
    name: function () {
        var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return M;
    },
    type: function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'mobile-web' : 'desktop-web';
    },
};
/* tslint:enable */
var Session = /** @class */ (function () {
    function Session(timestamp, id) {
        this.id = id;
        var sessionId = exports.cookie.get('_uca_session_id');
        this.id = sessionId || exports.cookie.set('_uca_session_id', id || uuid(), (1 / 24));
        var serverStartTs = exports.cookie.get('_uca_session_start_ts');
        this.startTs = Number(serverStartTs || exports.cookie.set('_uca_session_start_ts', timestamp, (1 / 24)));
        var serverEndTs = exports.cookie.get('_uca_session_end_ts');
        this.endTs = Number(serverEndTs || exports.cookie.set('_uca_session_end_ts', timestamp + (60 * 60 * 1000), (1 / 24)));
    }
    Session.prototype.getId = function () {
        return this.id;
    };
    Session.prototype.getStartTs = function () {
        return this.startTs;
    };
    Session.prototype.getEndTs = function () {
        return this.endTs;
    };
    return Session;
}());
exports.Session = Session;
function getTime(serverTsDiff) {
    if (serverTsDiff === void 0) { serverTsDiff = 0; }
    return Date.now() - serverTsDiff;
}
exports.getTime = getTime;
function getReferrerDomain() {
    var a = document.createElement('a');
    a.href = document.referrer;
    return a.hostname.replace(/^www\./i, '');
}
exports.getReferrerDomain = getReferrerDomain;
function getUtmSource() {
    return document && document.referrer ? getReferrerDomain() : 'direct';
}
exports.getUtmSource = getUtmSource;
function getUtmMedium() {
    var domain = document.referrer ? getReferrerDomain() : null;
    if (domain) {
        if (domain.match(new RegExp('(google|yahoo|bing|baidu|aol|ask|excite|duckduckgo).([^/?]*)', 'i'))) {
            return 'organic';
        }
        else if (domain.match(new RegExp('(tumblr|flickr|pinterest|linkedin|youtube|twitter|facebook|instagram).([^/?]*)', 'i'))) {
            return 'social';
        }
        else {
            return '';
        }
    }
    else {
        return '';
    }
}
exports.getUtmMedium = getUtmMedium;
var cities = [
    'ahmedabad',
    'bangalore',
    'chennai',
    'delhi-ncr',
    'dubai',
    'hyderabad',
    'kolkata',
    'mumbai',
    'pune',
    'jaipur',
    'chandigarh'
];
function getUtmLanding() {
    var pageType = 'other';
    var pathname = window.location.pathname || '';
    if (pathname === '/' || ('/' + cities.join('/')).indexOf(pathname) !== -1) {
        pageType = 'homepage';
    }
    else if (pathname.indexOf('/request/') !== -1) {
        pageType = 'request';
    }
    else if (pathname.indexOf('/pro/') !== -1) {
        pageType = 'pro';
    }
    else if (pathname.indexOf('/s/') !== -1) {
        pageType = 'sem';
    }
    else if (pathname.match(new RegExp("[" + cities.join('|') + "-]+", 'i'))) {
        pageType = 'listing';
    }
    return pageType;
}
exports.getUtmLanding = getUtmLanding;
function getLandingPageType() {
    function includes(pathname) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var boolIncludes = false;
        args.forEach(function (arg) {
            if (pathname.indexOf(arg) !== -1)
                boolIncludes = true;
        });
        return boolIncludes;
    }
    function boolIsListingPage(pathname) {
        var res = false;
        cities.forEach(function (city) {
            if (includes(pathname, "/" + city + "-"))
                res = true;
        });
        return res;
    }
    var pathname = window.location.pathname || '';
    var mapping = {
        home_page: pathname === '/',
        city_page: includes("/" + cities.join('/'), pathname),
        sem_page: includes(pathname, '/s/'),
        nearme_page: includes(pathname, '-near-me'),
        nearme_listing_page: includes(pathname, '/near-me') && !includes(pathname, '-near-me'),
        content_portal_page: includes(pathname, '/weddings', '/homes', '/photos/', '/weddings/ideas', '/homes/ideas'),
        review_page: includes(pathname, '/reviews', 'customer_reviews'),
        pro_page: includes(pathname, '/pro/'),
        offers_page: includes(pathname, '/offers'),
        aboutus_page: includes(pathname, '/about'),
        contactus_page: includes(pathname, '/contact-us'),
        bookings_page: includes(pathname, '/bookings'),
        terms_page: includes(pathname, '/terms'),
        ideabook_page: includes(pathname, '/ideabook'),
        privacy_policy_page: includes(pathname, '/privacy_policy', '/privacy-policy'),
        rate_card_page: includes(pathname, '/rate-card'),
        add_reference_page: includes(pathname, '/add_reference'),
        add_review_page: includes(pathname, '/add_review'),
        provider_response_page: includes(pathname, '/provider_response'),
        edit_profile_page: includes(pathname, '/edit-profile'),
        subscription_page: includes(pathname, '/subscriptions'),
        helpcenter_page: includes(pathname, '/helpcenter', '/help-center'),
        order_successful_page: includes(pathname, '/ordersuccessful'),
        request_page: includes(pathname, '/request/'),
        article_page: includes(pathname, '/article'),
        job_summary_page: includes(pathname, '/jobSummary'),
        pitch_credits_page: includes(pathname, '/pitchCredits'),
        listing_page: boolIsListingPage(pathname),
    };
    return Object.keys(mapping).filter(function (key) { return mapping[key] === true; })[0] || 'other';
}
exports.getLandingPageType = getLandingPageType;
function getUtm(param) {
    switch (param) {
        case 'source':
            var utmSource = getUtmSource();
            return getQueryParam('utm_source') ||
                (utmSource === 'direct' || utmSource === 'urbanclap.com'
                    ? (exports.cookie.get('_uca_utm_source') || 'direct') : utmSource);
        case 'medium':
            return getQueryParam('utm_medium') ||
                getUtmMedium() ||
                exports.cookie.get('_uca_utm_medium') ||
                '';
        case 'campaign':
            return getQueryParam('utm_campaign') || exports.cookie.get('_uca_utm_campaign') || '';
        case 'term':
            return getQueryParam('utm_term') || exports.cookie.get('_uca_utm_term') || '';
        case 'content':
            return getQueryParam('utm_content') || exports.cookie.get('_uca_utm_content') || '';
        case 'landing':
            return exports.cookie.get('_uca_utm_landing') || getUtmLanding();
        case 'sub_id':
            return getQueryParam('sub_id') || exports.cookie.get('_uca_sub_id') || '';
        default:
            return '';
    }
}
exports.getUtm = getUtm;
function utmAttribution(attributionValidDays) {
    exports.cookie.set('_uca_utm_source', getUtm('source'), attributionValidDays);
    exports.cookie.set('_uca_utm_medium', getUtm('medium'), attributionValidDays);
    exports.cookie.set('_uca_utm_campaign', getUtm('campaign'), attributionValidDays);
    exports.cookie.set('_uca_utm_term', getUtm('term'), attributionValidDays);
    exports.cookie.set('_uca_utm_content', getUtm('content'), attributionValidDays);
    exports.cookie.set('_uca_utm_landing', getUtm('landing'), attributionValidDays);
    exports.cookie.set('_uca_sub_id', getUtm('sub_id'), (1 / 24));
}
exports.utmAttribution = utmAttribution;
function fireXhr(url, data, method, headers, callback) {
    var request = new XMLHttpRequest();
    if (typeof callback === 'function') {
        request.onreadystatechange = function () {
            if (request.readyState === 4) {
                callback(request);
            }
        };
    }
    request.open(method, url, true);
    var headersObj = __assign({}, headers, { 'x-device-os': window.acmw.config.deviceOs, 'x-version-name': window.acmw.config.appVersion });
    if (headersObj) {
        Object.keys(headersObj).map(function (header) {
            headersObj[header] && request.setRequestHeader(header, headersObj[header]);
        });
    }
    request.send(JSON.stringify(data));
}
exports.fireXhr = fireXhr;
function serverSync(callback, failedAttempts) {
    fireXhr("https://event-api.urbanclap.com/getconfig?ts=" + (new Date()).getTime(), {}, 'GET', {}, function (req) {
        if (req.status === 200) {
            var data = JSON.parse(req.response);
            callback(data, failedAttempts);
        }
        else {
            if (failedAttempts) {
                failedAttempts++;
            }
            else {
                failedAttempts = 1;
            }
            if (failedAttempts < 3) {
                serverSync(callback, failedAttempts);
            }
        }
    });
}
exports.serverSync = serverSync;
function fireSession(session, serverTsDiff, config, defaultData) {
    var sessionData = [{
            event_timestamp: getTime(serverTsDiff).toString(),
            client_timestamp: (+new Date()).toString(),
            schema_type: 'session',
            session: {
                session_id: session.getId(),
                start_timestamp: session.getStartTs().toString(),
                landing_page: window.location.pathname,
                user_landing: getUtm('landing'),
                landing_page_type: getLandingPageType()
            },
            user: {
                user_type: config.userType || '',
                user_id: exports.cookie.get('_uc_user_id') || '',
            },
            client: {
                client_type: exports.browserInfo.type(),
                device_id: defaultData.uuid,
                device_os: defaultData.userAgent,
                version: config.appVersion + "-" + config.version,
            },
            install_source: {
                utm_source: exports.cookie.get('_uca_utm_source') || '',
                utm_term: getQueryParam('utm_term') || '',
                utm_medium: exports.cookie.get('_uca_utm_medium') || '',
                utm_campaign: exports.cookie.get('_uca_utm_campaign') || '',
                utm_content: exports.cookie.get('_uca_utm_content') || '',
                utm_text: getQueryParam('utm_text') || '',
                gclid: getQueryParam('gclid'),
                af_pid: exports.cookie.get('_uca_sub_id') || getQueryParam('af_pid') || '',
                af_campaign: exports.cookie.get('_uc_wt_version') || 'A',
                af_install_time: '',
                af_click_time: '',
            },
        }];
    fireXhr(config.eventApi.url, sessionData, config.eventApi.requestMethod, config.eventApi.headers);
    return true;
}
exports.fireSession = fireSession;
//# sourceMappingURL=serverEvents.js.map